import { inject, NgModule, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
// import { ButtonComponent } from './button.component';
import { AppRoutingModule } from './app-routing.module';
import {PreloginComponent} from './prelogin/prelogin.component';
import { FindYourFeeComponent } from './findyourfee/findyourfee.component';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './component/material/material.module';
import { DashboardComponent } from './view/dashboard/dashboard.component';
// import { ConnectComponent } from './view/connect/connect.component';
import { SupportComponent } from './view/support/support.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import { MatButtonModule } from '@angular/material/button';
import {MatBadgeModule} from '@angular/material/badge';
import { HTTP_INTERCEPTORS,HttpClientModule } from '@angular/common/http';
import { SppDialogBoxComponent } from './component/spp-dialog-box/spp-dialog-box.component';
import { HashLocationStrategy,LocationStrategy } from '@angular/common';
import { ImportModalComponent } from './component/import-modal/import-modal.component';
import { ProgressbarComponent } from './component/progressbar/progressbar.component';
import { DragNdropDirective } from './directives/drag-ndrop.directive';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CdkTableModule } from '@angular/cdk/table';
import { FormsModule } from '@angular/forms';
// import { TrainingComponent } from './view/training/training.component';
// import { MarketingComponent } from './view/marketing/marketing.component';
// import { AccountComponent } from './view/account/account.component';
// import { ProfileComponent } from './view/profile/profile.component';
// import { PartnerprofileComponent } from './view/partnerprofile/partnerprofile.component';
import { MycompanyComponent } from './view/mycompany/mycompany.component';
// import { HelprequestComponent } from './view/support/helprequest/helprequest.component';
import {MatDividerModule} from '@angular/material/divider';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CommonModule } from '@angular/common';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { CoursewareComponent } from './view/courseware/courseware.component';
import { VssComponent } from './view/vss/vss.component';
// import { ClassesComponent } from './view/classes/classes.component';
import { LiveComponent } from './view/live/live.component';
import { VouchersComponent } from './view/vouchers/vouchers.component';
import { TruncateTextDirective } from './directives/apptruncatetext.directive';
import { AnnouncementComponent } from './view/dashboard/announcement/announcement.component';
import {MatStepperModule} from '@angular/material/stepper';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ErrorComponent } from './view/error/error.component';
import { DomainErrorComponent } from './view/domain-error/domain-error.component';
// import { InstructorComponent } from './view/instructor/instructor.component';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { RecaptchaModule,RecaptchaFormsModule  } from 'ng-recaptcha';
import Utils from './utils/utils';
import {
  TopazGlobalBarModule,
  TopazFooterModule,
  TopazSidenavModule,
  TopazTileModule,
  TopazTableOptionsModule,
  TopazCapsuleModule,
  TopazBadgeModule,
  TopazSearchModule,
  TopazFilterModule,
  TopazToastModule,
  TopazDirectivesModule,
  TopazBannerModule, 
} from '@pearsonvue/topaz-angular-ui';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MatSortModule } from '@angular/material/sort';
import { ErrorInterceptor, HeaderInterceptor } from './interceptors/interceptor';
import { ToastExampleComponent } from './component/toast-example/toast-example.component';
import { ToastSuccessComponent } from './component/toast-success/toast-success.component';
import { LoginComponent } from './view/login/login.component';
import { LogoutModalComponent } from './component/logout-modal/logout-modal.component';
import { RegisterTrainingFormComponent } from './view/training/register-training-form/register-training-form.component';
import { MctDataModalComponent } from './component/mct-data-modal/mct-data-modal.component';
import { UserDataModalComponent } from './component/user-data-modal/user-data-modal.component';
import { IscpDataModalComponent } from './component/iscp-data-modal/iscp-data-modal.component';
import { EmailUpdateFormComponent } from './view/email-update-form/email-update-form.component';
import { HomeComponent } from './view/home/home.component';
import { MatDialogModule } from '@angular/material/dialog';
import { AnnouncementDialogueComponent } from './view/home/announcement-dialogue/announcement-dialogue.component';
import { TechCommunitiesModalComponent } from './component/tech-communities-modal/tech-communities-modal.component';
import { TechCommunityComponent } from './view/tech-community/tech-community.component';
import { ExtremeLabComponent } from './view/extreme-lab/extreme-lab.component';
import { TermsComponent } from './view/terms/terms.component';
import { UserPaymentModalComponent } from './component/user-payment-modal/user-payment-modal.component';
import { PreSubmissionModalComponent } from './component/pre-submission-modal/pre-submission-modal.component';
import { EmailChangeConfirmationModalComponent } from './component/email-change-confirmation-modal/email-change-confirmation-modal.component';
import { AlumniRequestComponent } from './view/alumni-request/alumni-request.component';
import { FormSelectionComponent } from './component/form-selection/form-selection.component';
// import { ModeSelectionComponent } from './view/mode-selection/mode-selection.component';
import { ExpiredFormSubmissionComponent } from './view/expired-form-submission/expired-form-submission.component';
import { ReinstateRequestComponent } from './view/reinstate-request/reinstate-request.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { TestOutFailModalComponent } from './component/test-out-fail-modal/test-out-fail-modal.component';
import { ILTSessionListComponent } from './view/iltsession-list/iltsession-list.component';
import { TrainingSelectionModalComponent } from './component/training-selection-modal/training-selection-modal.component';
// import { AppInitializerService } from './services/app-initializer.service';
import { ISCPFormsComponent } from './view/Forms/iscpforms/iscpforms.component';
import { ILTFormComponent } from './view/Forms/iltform/iltform.component';
import { FTEModalComponent } from './component/fte-modal/fte-modal.component';
import { YoodliRegConfirmationComponent } from './component/yoodli-reg-confirmation/yoodli-reg-confirmation.component';
import { AppendixAComponent } from './view/appendix-a/appendix-a.component';
import { PageHeaderComponent } from './component/page-header/page-header.component';
import { UserPageLoaderComponent } from './component/user-page-loader/user-page-loader.component';
    
@NgModule({
  declarations: [
    TruncateTextDirective,
    PreloginComponent,
    FindYourFeeComponent,
    AppComponent,
    DashboardComponent,
    // ConnectComponent,
    SupportComponent,
    SppDialogBoxComponent,
    // ButtonComponent,
    ImportModalComponent,
    ProgressbarComponent,
    DragNdropDirective,
    // TrainingComponent,
    // MarketingComponent,
    // AccountComponent,
    // ProfileComponent,
    ToastExampleComponent,
    ToastSuccessComponent,
    // PartnerprofileComponent,
    LoginComponent,
    LogoutModalComponent,
    YoodliRegConfirmationComponent,
    AppendixAComponent,
    // HelprequestComponent,
    MycompanyComponent,
    RegisterTrainingFormComponent,
    CoursewareComponent,
    VssComponent,
    // ClassesComponent,
    LiveComponent,
    VouchersComponent,
    AnnouncementComponent,
    MctDataModalComponent,
    IscpDataModalComponent,
    UserDataModalComponent,
    EmailUpdateFormComponent, 
    HomeComponent ,
    AnnouncementDialogueComponent,
    ErrorComponent,
    DomainErrorComponent,
    TechCommunitiesModalComponent,
    TechCommunityComponent,
    ExtremeLabComponent,
    TermsComponent,
    UserPaymentModalComponent,
    PreSubmissionModalComponent,
    EmailChangeConfirmationModalComponent,
    AlumniRequestComponent,
    FormSelectionComponent,
    // ModeSelectionComponent,
    ExpiredFormSubmissionComponent,
    ReinstateRequestComponent,
    // InstructorComponent,
    TestOutFailModalComponent,
    ILTSessionListComponent,
    TrainingSelectionModalComponent,
    ISCPFormsComponent,
    ILTFormComponent,
    FTEModalComponent,
    PageHeaderComponent,
    UserPageLoaderComponent,
  ],
  imports: [
    FlexLayoutModule,
    MatButtonModule,
    MatSortModule,
    BrowserModule,                                                       
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    MatNativeDateModule,
    MatDatepickerModule,
    HttpClientModule,
    MatInputModule,
    MatSidenavModule,
    MatButtonToggleModule,
    MatBadgeModule,
    TopazGlobalBarModule,
    TopazFooterModule,
    TopazSidenavModule,
    FontAwesomeModule,
    TopazTileModule,
    TopazTableOptionsModule,
    MatSlideToggleModule,
    CdkTableModule,
    TopazCapsuleModule,
    FormsModule,
    TopazBadgeModule,
    TopazSearchModule,
    TopazFilterModule,
    MatDividerModule,
    TopazToastModule,
    TopazDirectivesModule,
    CommonModule,
    MatStepperModule,
    MatProgressSpinnerModule,
    TopazBannerModule,
    MatDialogModule,
    ClipboardModule,
    MatFormFieldModule,
    MatCardModule,
    MatIconModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    ReactiveFormsModule
  ],
  providers: [{provide:LocationStrategy,useClass:HashLocationStrategy}, Utils,provideAnimationsAsync(),
  //   {
  //   provide: TOPAZ_SIDENAV_GROUPED_LIST,
  //   useValue: groupedList
  // },
  {
  provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: {
        position: 'before'
      }
    },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HeaderInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorInterceptor,
    multi: true
  },
  //provideAppInitializer(() => inject(AppInitializerService).initializeUserDetails()),
],
  bootstrap: [AppComponent]
})
export class AppModule { }
